import { useDecision } from '@optimizely/react-sdk';
import DynamicForm, { FormValuesOutput } from '@policygenius/mortar-dynamic-forms';
import { useCreateDataPointValues, useGetDataPointValues } from 'api/hooks/useDataPointValues';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { completedNavigatorStep } from 'analytics/navigator';
import { StepName } from 'analytics/navigator/constants';
import DynamicFormWrapper from 'components/DynamicFormWrapper';
import GlobalLoader from 'components/GlobalLoader';
import NavigatorContent from 'components/NavigatorContent';
import {
  CONTINUE_ONLINE_FINANCES_PATH,
  CONTINUE_ONLINE_HAZARDOUS_ACTIVITIES_PATH,
} from 'routes/constants';
import useSelector from 'store/useSelector';
import { Flags } from 'util/optimizely/types';

import schema from './schema';
import { FormValues } from './types';

const INTERVIEW_URNS: Array<keyof FormValues> = [
  'urn:pg:data-point:insured-citizenship',
  'urn:pg:data-point:insured-non-citizen-length-of-us-stay',
  'urn:pg:data-point:insured-residency-status',
  'urn:pg:data-point:insured-visa-type',
];

const Citizenship: React.FC = () => {
  const activeUserUuid = useSelector((app) => app.activeUserUuid);
  const navigate = useNavigate();
  const [{ enabled: funnelRemixP2 }] = useDecision(Flags.LIFE_FUNNEL_REMIX_P2);

  const { createDataPointValuesFromInterview } = useCreateDataPointValues({
    onCompleted: () => {
      completedNavigatorStep(StepName.CITIZENSHIP, activeUserUuid);

      funnelRemixP2
        ? navigate(`../${CONTINUE_ONLINE_FINANCES_PATH}`)
        : navigate(`../${CONTINUE_ONLINE_HAZARDOUS_ACTIVITIES_PATH}`);
    },
  });

  const { data, loading } = useGetDataPointValues({ params: { urns: INTERVIEW_URNS } });

  const onSubmit = async (values: FormValuesOutput<FormValues>) => {
    await createDataPointValuesFromInterview(values, schema);
  };

  if (loading) {
    return <GlobalLoader />;
  }

  return (
    <NavigatorContent>
      <DynamicFormWrapper>
        <DynamicForm<FormValues>
          name="citizenship"
          schema={schema}
          onSubmit={onSubmit}
          initialValues={data?.dataPointValues}
        />
      </DynamicFormWrapper>
    </NavigatorContent>
  );
};

export default Citizenship;
